<template>
  <div
    ref="hero"
    class="md:flex locations-hero-wrapper bg-light-purple relative"
  >
    <div
      class="relative w-full h-full lg:h-auto lg:w-auto lg:flex lg:flex-col lg:container py-32 md:py-44 bg-cover bg-no-repeat bg-center md:bg-none"
      :class="!smallText ? 'location-hero-text-wrap' : ''"
      :style="`background-image: url(${optimiseImg})`"
    >
      <div class="md:w-1/2">
        <template v-if="breadcrumbs.length">
          <BlocksHeroBreadcrumbs :breadcrumbs="breadcrumbs" theme="dark" class="absolute z-20 breadcrumbs top-4 left-4 md:top-12 md:left-4 hidden md:block" :class="{ 'animate' : animatedHero }" />
          <BlocksHeroBreadcrumbs :breadcrumbs="breadcrumbs" theme="light" class="absolute z-20 breadcrumbs top-4 left-4 md:top-8 md:left-4 block md:hidden" :class="{ 'animate' : animatedHero }" />
        </template>
        <div class="flex flex-col justify-center hero-body container-to-md lg:order-1 lg:pr-xl" :class="{ 'animate' : animatedHero }">
          <h1
            class="text-center text-white uppercase font-druk md:leading-13 md:tracking-02-em md:text-left md:text-black relative z-30 overflow-hidden"
            :class="smallText ? ['hidden md:block md:text-display-14', 'md:leading-13'] : ['text-display-10', 'md:text-display-25', 'md:leading-22']"
          >
            <span class="inline-block text">{{ title }}</span>
          </h1>

          <p
            class="content hidden md:block font-light text-center md:text-left content -tracking-01-em md:-tracking-04-em md:leading-8 md:mt-semi text-dark mb-0"
            :class="smallText ? ['md:text-base', 'mt-semi'] : ['md:text-display-7', 'mt-semi']"
          >
            {{ body }}
          </p>
        </div>
      </div>
    </div>
    <h1
      class="text-center uppercase font-druk -tracking-01-em leading-10 pt-semi px-11"
      :class="smallText ? ['block', 'md:hidden', 'text-display-11'] : ['hidden', 'text-display-10']"
    >
      {{ title }}
    </h1>
    <p
      class="mb-0 md:hidden font-light text-center content -tracking-01-em lg:text-left lg:mt-semi text-dark px-semi pt-semi pb-large bg-light-purple"
      :class="smallText ? ['text-smallest px-tiny md:text-base'] : ['font-gt-america-extended uppercase text-smallest']"
    >
      {{ body }}
    </p>
    <div class="location-hero-image bg-cover bg-no-repeat bg-center md:w-1/2 absolute" :style="`background-image: url(${optimiseImg})`" />
  </div>
</template>

<script>
import { optimize } from '@/utils/image-optimization'

export default {
  props: {
    title: {
      type: [String, Array],
      required: true,
      default: () => []
    },
    body: {
      type: String,
      default: ''
    },
    smallText: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    },
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup () {
    const { $device } = useNuxtApp()
    return $device
  },
  data () {
    return {
      animatedHero: false
    }
  },
  computed: {
    optimiseImg () {
      const url = this.imageUrl
      return optimize(url, false, this.getOptmizeOptions)
    },
    getOptmizeOptions () {
      const imgWidth = this.$device.isMobile ? 640 : 1024
      return { w: imgWidth }
    }
  },
  mounted () {
    this.animatedHero = true
  }
}
</script>

<style lang="postcss" scoped>
.locations-hero-wrapper {
  margin-top: var(--navbar-height);
}
  .location-hero-text-wrap::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, .4);
  }

  .breadcrumbs {
    opacity: 0;
    transition: opacity 0.8s 0.8s cubic-bezier(0.76, 0, 0.24, 1);

    @screen lg {
      transition: opacity 0.8s cubic-bezier(0.76, 0, 0.24, 1);
    }

    &.animate {
      opacity: 1;
    }
  }

  .location-hero-image {
    inset: 0 0 0 auto;
  }

  .hero-body {
    @screen lg {
      .text {
        transform: translateY(100%);
      }
      .content {
        opacity: 0;
        transition: opacity 0.8s cubic-bezier(0.76, 0, 0.24, 1);
      }
    }
    &.animate {
      @screen lg {
        .text {
          animation: slideIn 0.8s 0s cubic-bezier(0.76, 0, 0.24, 1) forwards;
        }

        .content {
          opacity: 1;
        }
      }
    }
  }

  @screen md {
    .location-hero-text-wrap::before {
      content: none;
    }
  }

  @keyframes slideIn {
  0%   {
    transform: translateY(120%);
  }
  100% {
    transform: translateY(0);
  }
}

</style>
